// extracted by mini-css-extract-plugin
export default {"panel":"CompanyReportsPanel_panel__nb81B"};